import React, { lazy } from 'react';
import authRoles from '../../../auth/authRoles';

const MailTemplatesMailTemplates = lazy(() => import('./mailTemplates/MailTemplates'));

const MailTemplatesAppConfig = {
	settings: {
		layout: {},
	},
	auth: authRoles.ameroAdmin,
	routes: [
		{
			path: '/apps/mail-templates',
			element: <MailTemplatesMailTemplates />,
		},
	],
};

export default MailTemplatesAppConfig;
